module.exports = __webpack_public_path__ + "static/media/hdd.45423e42.svg";